import type {
  WorkOrderPriority,
  WorkOrderServiceCategory,
  WorkOrderServiceItem,
} from '@backoffice-frontend/graphql'
import { useTranslation } from 'react-i18next'

export const useWorkOrderServiceItemTranslation = () => {
  const { t } = useTranslation()

  return (serviceItem: WorkOrderServiceItem): string => {
    const options: Record<WorkOrderServiceItem, string> = {
      CLEANING: t('workOrdersComponents_workOrdersTable_serviceItem_cleaning'),
      SPECIAL_CLEANING: t(
        'workOrdersComponents_workOrdersTable_serviceItem_specialCleaning',
      ),
      VEHICLE_LETTERING: t(
        'workOrdersComponents_workOrdersTable_serviceItem_vehicleLettering',
      ),
      TRANSFER_RIDE: t(
        'workOrdersComponents_workOrdersTable_serviceItem_transferRide',
      ),
      TABLET_UPDATE: t(
        'workOrdersComponents_workOrdersTable_serviceItem_tabletUpdate',
      ),
      SEAT_COMPLAINT: t(
        'workOrdersComponents_workOrdersTable_serviceItem_seatComplaint',
      ),
      SMART_REPAIR_DENT: t(
        'workOrdersComponents_workOrdersTable_serviceItem_smartRepairDent',
      ),
      SMART_REPAIR_PAINTWORK: t(
        'workOrdersComponents_workOrdersTable_serviceItem_smartRepairPaintwork',
      ),
      ACTION_MANUFACTURER: t(
        'workOrdersComponents_workOrdersTable_serviceItem_actionManufacturer',
      ),
      ACTION_INTERNAL: t(
        'workOrdersComponents_workOrdersTable_serviceItem_actionInternal',
      ),
      BRAKE_FLUID_CHANGE: t(
        'workOrdersComponents_workOrdersTable_serviceItem_brakeFluidChange',
      ),
      CHARGING: t('workOrdersComponents_workOrdersTable_serviceItem_charging'),
      INSIDE_CLEANING: t(
        'workOrdersComponents_workOrdersTable_serviceItem_insideCleaning',
      ),
      DEMO_CLEANING: t(
        'workOrdersComponents_workOrdersTable_serviceItem_demoCleaning',
      ),
      OUTSIDE_CLEANING: t(
        'workOrdersComponents_workOrdersTable_serviceItem_outsideCleaning',
      ),
      INTERNAL_INSPECTION: t(
        'workOrdersComponents_workOrdersTable_serviceItem_internalInspection',
      ),
      IN_FIELD_SUPPORT: t(
        'workOrdersComponents_workOrdersTable_serviceItem_inFieldSupport',
      ),
      MAIN_INSPECTION: t(
        'workOrdersComponents_workOrdersTable_serviceItem_mainInspection',
      ),
      MILEAGE_INSPECTION: t(
        'workOrdersComponents_workOrdersTable_serviceItem_mileageInspection',
      ),
      MAINTENANCE: t(
        'workOrdersComponents_workOrdersTable_serviceItem_maintenance',
      ),
      SPARE_PARTS_REQUEST: t(
        'workOrdersComponents_workOrdersTable_serviceItem_sparePartsRequest',
      ),
      ATTACH_DATA_PRIVACY_SIGNS: t(
        'workOrdersComponents_workOrdersTable_serviceItem_attachDataPrivacySigns',
      ),
      DAMAGE_CHECK: t(
        'workOrdersComponents_workOrdersTable_serviceItem_damageCheck',
      ),
      TECHNICAL_VEHICLE_CHECK: t(
        'workOrdersComponents_workOrdersTable_serviceItem_technicalVehicleCheck',
      ),
      VEHICLE_SOFTWARE_UPDATE: t(
        'workOrdersComponents_workOrdersTable_serviceItem_vehicleSoftwareUpdate',
      ),
      OTHER: t('workOrdersComponents_workOrdersTable_serviceItem_other'),
    }
    return options[serviceItem] ?? serviceItem
  }
}

export const useWorkOrderServiceCategoryTranslation = () => {
  const { t } = useTranslation()

  return (workOrderServiceCategory: WorkOrderServiceCategory): string => {
    const options: Record<WorkOrderServiceCategory, string> = {
      DAMAGES_DEFECTS: t(
        'workOrdersComponents_workOrdersTable_category_damagesDefects',
      ),
      IVC: t('workOrdersComponents_workOrdersTable_category_ivc'),
      HUB_ACTIVITIES: t(
        'workOrdersComponents_workOrdersTable_category_hubActivities',
      ),
      MAINTENANCE_SERVICE: t(
        'workOrdersComponents_workOrdersTable_category_maintenanceService',
      ),
      INCIDENT: t('workOrdersComponents_workOrdersTable_category_incident'),
      OTHER: t('workOrdersComponents_workOrdersTable_category_other'),
    }
    return options[workOrderServiceCategory] ?? workOrderServiceCategory
  }
}

export const usePriorityTranslation = () => {
  const { t } = useTranslation()

  return (priority: WorkOrderPriority): string => {
    const options: Record<WorkOrderPriority, string> = {
      HIGH: t('workOrdersComponents_workOrdersTable_priority_high'),
      LOW: t('workOrdersComponents_workOrdersTable_priority_low'),
      MEDIUM: t('workOrdersComponents_workOrdersTable_priority_medium'),
    }
    return options[priority] ?? priority
  }
}
